<div class="card-outline">
  <div class="resolution-message-ellipsis-row">
    <div
      data-cy="product-card-resolution-message-section"
      class="resolution-message-column"
    >
      <p
        [attr.data-cy]="
          'product-resolution-message-' + product?.productNumber + '-text'
        "
      >
        <ion-icon
          [attr.data-cy]="
            'product-resolution-message-' + product?.productNumber + '-icon'
          "
          name="sync-outline"
        ></ion-icon>
        <span>
          {{ productCardResolutionMsg?.primaryText | translate }}
          <span
            *ngIf="!!productCardResolutionMsg?.secondaryText"
            class="secondary-text"
          >
            <span class="bold">
              {{ productCardResolutionMsg?.secondaryText | translate }}
            </span>
            <span *ngIf="!!productCardResolutionMsg?.tertiaryText">
              {{ productCardResolutionMsg?.tertiaryText | translate }}
            </span>
            <span
              *ngIf="!!productCardResolutionMsg?.tertiaryTextDate"
              [ngStyle]="productCardResolutionMsg?.tertiaryTextDateStyle"
            >
              {{ productCardResolutionMsg?.tertiaryTextDate | translate }}
            </span>
          </span>
        </span>
      </p>
    </div>
    <div class="ellipsis-column" *ngIf="mode !== productCardModes.modifyVS">
      <div
        class="ellipsis-icon-transparent"
        *ngIf="
          mode === productCardModes.tmNoteDetails ||
          mode === productCardModes.addToInventory
        "
      >
        <ion-icon name="ellipsis-vertical-circle-sharp"></ion-icon>
      </div>
      <app-product-card-ellipsis
        *ngIf="
          mode !== productCardModes.tmNoteDetails &&
          mode !== productCardModes.addToInventory
        "
        [notFound]="
          (orderService.restrictNavigationForCurrentOrder$ | async) ||
          product?.notFound
        "
        (ellipsisClickEmitter)="ellipsisClick($event)"
        [isGuestUser]="isGuestUser"
      >
      </app-product-card-ellipsis>
    </div>
  </div>
  <div class="product-info-ordering-row">
    <div class="image-column">
      <app-product-card-image
        [isOnline]="panAppState.online$ | async"
        [imageThumbnail]="product?.imageThumbnail"
        [productNumber]="product?.productNumber"
        [height]="3.5"
        [width]="3.5"
        [clickable]="clickable && !product?.notFound && !product?.isNonUsf"
        (productImageClickEmitter)="productImageClick()"
      ></app-product-card-image>
    </div>
    <div class="info-column">
      <app-product-card-information
        [brand]="product?.summary?.brand"
        [description]="product?.summary?.productDescTxtl"
        [productNumber]="product?.productNumber"
        [salesPackSize]="product?.summary?.salesPackSize"
        [showNote]="false"
        [notFound]="product?.notFound"
        [isSplitCard]="true"
        [customerProductNumber]="product?.customerProductNumber"
        [showPowerReview]="false"
        [pricePerPortion]="product?.pricePerPortion"
        (itemNoteClickEmitter)="itemNoteClick()"
        (productDescriptionClickEmitter)="productClick()"
        [truncateAmount]="
          platformService.platformType === platformService.platformEnum.desktop
            ? 53
            : platformService.platformType ===
                platformService.platformEnum.mobile
              ? 30
              : 25
        "
        [clickable]="clickable && !product?.isNonUsf"
        [isGuestUser]="isGuestUser"
      >
      </app-product-card-information>
    </div>
    <div class="ordering-column">
      <app-product-card-ordering
        [productSummary]="product?.summary"
        [pricing]="product?.pricing"
        [casesOrdered]="product?.casesOrdered"
        [eachesOrdered]="product?.eachesOrdered"
        [isOrderable]="product?.orderable"
        [isOnline]="panAppState.online$ | async"
        [platformType]="this.platformService?.platformType"
        [index]="index"
        [listId]="listId"
        [hotkeyIds]="product?.hotkeyIds"
        [pricingDisabled]="pricingDisabled"
        [mode]="mode"
        [notFound]="product?.notFound"
        [hideQuantityBoxes]="product?.hideQuantityBoxes"
        [isSplitCard]="true"
        (quantityUpdateEmitter)="changeQuantityHandler($event)"
        (quantityElementEmitter)="quantityInputUpdate($event)"
        (mouseover)="handleMouseOver($event)"
        (mouseleave)="handleMouseLeave()"
        [isGuestUser]="isGuestUser"
      >
      </app-product-card-ordering>
    </div>
  </div>
  <div
    *ngIf="
      mode === productCardModes.defaultSearch && alternatePowerReviewRollupModel
    "
    class="power-review-row"
  >
    <app-power-custom-review-rating-stars
      [powerReviewRollupModel]="alternatePowerReviewRollupModel"
      [ratingStarsCSSEnum]="ratingStarsCSSEnum.ALTERNATIVE_PRODUCT"
      [ratingAverageCSSEnum]="ratingAverageCSSEnum.ALTERNATIVE_PRODUCT"
    ></app-power-custom-review-rating-stars>
  </div>
  <div class="tags-promotions-row">
    <div class="tags-column">
      <app-usf-product-tag-list
        [tagList]="product?.productTags"
        [infoIconEnabled]="false"
        [allTagsClickable]="true"
        [product]="transformProductToProductDetail()"
        [maxTags]="2"
      >
      </app-usf-product-tag-list>
    </div>
    <div class="promotions-column">
      <app-product-card-promotions-banner
        *ngIf="
          mode !== productCardModes.listManagement &&
          mode !== productCardModes.addToInventory &&
          product?.promotionDetails
        "
        [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
        [productNumber]="product?.summary?.productNumber"
        (bannerClickEmitter)="promotionClick($event)"
      >
      </app-product-card-promotions-banner>
    </div>
  </div>
</div>
